export const customToolbarSettings = {
  items: ['FontName', 'FontSize', 'Bold', 'Italic', 'Alignments', 'CreateLink', 'CreateTable', 'FontColor', 'BackgroundColor', 'Undo', 'Redo'],
};
